module.exports = __webpack_public_path__ + "media/images/flags/4x3/sle-367f5c71c57874cf0f8c3a834d6cdbb4.svg";